// extracted by mini-css-extract-plugin
export var cardIcon = "_aj-4";
export var checkboxCard = "_aj-0";
export var checkboxCardSelected = "_aj-1";
export var disabled = "_aj-2";
export var outerBorder = "_aj-3";
export var spacerMedium = "_aj-7";
export var spacerSmall = "_aj-6";
export var spacerXsmall = "_aj-5";